import { Component, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LayoutService, ScreenSize } from 'libs/portal/src/layout/layout.service';
import { GenericService } from 'libs/portal/src/services/generic/generic.service';
import { Endpoints } from '@huge-monorepo/portal/config';
import { DeviceDetailsModalComponent } from '../../device-details-modal/device-details-modal.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-device-list-modal',
  templateUrl: './device-list-modal.component.html',
  styleUrls: ['./device-list-modal.component.scss'],
})
export class DeviceListModalComponent {
  deviceIds: number[];
  ScreenSize = ScreenSize;
  constructor(
    private params: ActivatedRoute,
    private genericService: GenericService,
    private endpoints: Endpoints,
    private layoutService: LayoutService,
    private dialogRef: MatDialogRef<DeviceListModalComponent>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) deviceData: { deviceIds: number[] },
  ) {
    if (deviceData != null) {
      this.deviceIds = deviceData.deviceIds;
    }
  }

  async closeModal() {
    this.dialogRef.close();
  }

  getDeviceData(deviceId: number) {
    this.genericService.POST(this.endpoints.GET_DEVICE(), { KaID: deviceId }).subscribe((data: any) => {
      this.showDeviceDetailsModal(data);
      this.closeModal();
    });
  }

  async showDeviceDetailsModal(data: any) {
    const style: string = this.layoutService.screenSize > this.ScreenSize.MOBILE_L ? 'auto-height' : '';

    const dialog = this.dialog.open(DeviceDetailsModalComponent, {
      data: { data: data },
    });
  }
}
